/**
 * The non-money formatters the review surfaces share. Money never lives here: a service
 * price goes through `lib/formatMoney.js#formatMoneyCode` with the currency the server
 * stated on the row.
 */
import { dateLocale } from "../i18n/dateLocale";

/** The placeholder for a value the server sent as `null` — punctuation, not prose. */
export const EMPTY = "—";

/**
 * An ISO-8601 instant as a date in the reader's locale, `EMPTY` when absent or unreadable.
 * A review row's `slot_start` is copied verbatim from the booking and `reply.at` is null
 * until the practitioner answers; neither may ever render as "Invalid Date".
 */
export const fmtDate = (iso, lang) => {
  if (!iso) return EMPTY;
  const ms = Date.parse(iso);
  return Number.isFinite(ms) ? new Date(ms).toLocaleDateString(dateLocale(lang)) : EMPTY;
};

/**
 * An ISO-8601 instant as date + time in the reader's locale — the appointment a client is
 * about to review, stated the way `ClientPortal` states the same booking (`dateStyle:
 * medium, timeStyle: short`).
 */
export const fmtDateTime = (iso, lang) => {
  if (!iso) return EMPTY;
  const ms = Date.parse(iso);
  if (!Number.isFinite(ms)) return EMPTY;
  return new Date(ms).toLocaleString(dateLocale(lang), { dateStyle: "medium", timeStyle: "short" });
};

/**
 * An average rating to ONE decimal ("4.3"), the contract's display rule: the server rounds
 * to two, the SPA shows one. `null`/non-finite → `EMPTY`, so a practice before its first
 * review never prints "NaN" or "0.0".
 */
export const fmtAvg = (avg) => {
  const n = Number(avg);
  return avg == null || !Number.isFinite(n) ? EMPTY : n.toFixed(1);
};
